/* src/app/modules/contact/contact-tabs.component.scss */
/*# sourceMappingURL=contact-tabs.component.css.map */
